// Third party
import { useQuery } from '@tanstack/react-query';

// Hooks
import { useAppDispatch } from '../../useAppStore';
import { ProfileController } from '../../../services';

// Components
import { useError } from '../../useError';
import { QUERY_KEYS } from '../../../utils';
import { profileDataActions } from '../../../store';
import { TAxiosError, TGetProfileInfoRes } from '../../../types/responses';

const useGetProfileInfo = () => {
  const dispatch = useAppDispatch();
  const { handleReqError } = useError();

  return useQuery({
    queryKey: [QUERY_KEYS.PROFILE.PROFILE],
    queryFn: async () => {
      try {
        const rsp = await ProfileController().getProfileInfo<TGetProfileInfoRes>();
        dispatch(profileDataActions.setProfileInfo(rsp.data));
        return rsp.data;
      } catch (err) {
        await handleReqError(err as TAxiosError);
      }
    },
    enabled: false,
  });
};

export { useGetProfileInfo };
